import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'

export default defineNuxtPlugin(() => {
	if (process.server) return
	const notyf = new Notyf({
		position: {
			x: 'center',
			y: 'top',
		},
		duration: 3000,
	})
	return {
		provide: {
			notyf,
		},
	}
})
